export default function handleSubmit(values) {
    const REST_API_URL = "Home";
        fetch(REST_API_URL, {
          method: 'post',
          body: JSON.stringify(values)
        }).then(response => {
          if (response.ok) {
            return response.json();
          } else {
            // HANDLE ERROR
            throw new Error('Something went wrong');
          }
        }).then(data => {
          // HANDLE RESPONSE DATA
          console.log(data);
        }).catch((error) => {
          // HANDLE ERROR
          console.log(error);
        });
}
